// extracted by mini-css-extract-plugin
export default {"imgBox":"sdms2D_imgBox__YGEP5","mainImage":"sdms2D_mainImage__5Ju6S","poiImgs":"sdms2D_poiImgs__qdc2z","selectedPoiImgs":"sdms2D_selectedPoiImgs__OPFyQ"};